import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import { ciCustomColors } from "@/theme/colors";

type MuiFilledInput = {
  styleOverrides: ComponentsOverrides<Theme>["MuiFilledInput"];
  defaultProps?: ComponentsProps["MuiFilledInput"];
};

const muiInputBase: MuiFilledInput = {
  defaultProps: { size: "medium" },
  styleOverrides: {
    input: ({ ownerState }) => ({
      padding: ownerState.size === "medium" ? "8px 12px" : "4px 12px",
      paddingRight: ownerState.endAdornment ? 0 : "12px",
      paddingLeft: ownerState.startAdornment ? 0 : "12px",

      "&.Mui-disabled": {
        cursor: "not-allowed",
      },
    }),
    root: ({ theme, ownerState }) => ({
      backgroundColor: `${ciCustomColors.blue[10]}`,
      border: `1.5px solid ${ciCustomColors.blue[50]}`,
      borderRadius: "4px",
      borderBottomColor: ciCustomColors.blue[50],
      ...(ownerState.multiline && {
        padding: 0,
      }),

      ":hover": {
        backgroundColor: ciCustomColors.blue[10],
      },
      ":after": {
        // To prevent border bottom animation
        display: "none",
      },
      ":before": {
        // To prevent border bottom animation background
        display: "none",
      },
      "&.Mui-focused": {
        backgroundColor: ciCustomColors.blue[10],
        borderColor: ciCustomColors.blue[500],
        outline: `1px solid ${ciCustomColors.blue[500]}`,
      },
      "&.Mui-error": {
        border: `1.5px solid ${theme.palette.error.main}`,
        backgroundColor: ciCustomColors.red[100],
        "&.Mui-focused": {
          border: `1.5px solid ${theme.palette.error.main}`,
          outline: `1px solid ${theme.palette.error.main}`,
          backgroundColor: ciCustomColors.red[100],
        },
      },
      "&.Mui-disabled": {
        backgroundColor: ciCustomColors.blue[10],
        borderColor: ciCustomColors.blue[50],
        color: theme.palette.text.disabled,
      },
    }),
  },
};

export default muiInputBase;
